module.exports = __webpack_public_path__ + "static/media/dotx.95ccfd2d.png";